import { hyperdx } from '../hyperdx';
import type { HyperdxClient, HyperdxInitConfig } from '../integrations/hyperdx';
import type { LoggerRole } from '../logger';
import { createDefaultHyperdxWorker } from '../worker/defaultWorker';

export const browserHyperdxClient = hyperdx as HyperdxClient;

export const withDefaultHyperdxWorker = (
  configOrOptions?: HyperdxInitConfig | { role?: LoggerRole },
): HyperdxInitConfig | { role?: LoggerRole } | undefined => {
  if (!isHyperdxInitConfig(configOrOptions)) {
    return configOrOptions;
  }

  if (configOrOptions.mode !== 'worker' || configOrOptions.workerFactory) {
    return configOrOptions;
  }

  return {
    ...configOrOptions,
    workerFactory: createDefaultHyperdxWorker,
  };
};

const isHyperdxInitConfig = (
  configOrOptions?: HyperdxInitConfig | { role?: LoggerRole },
): configOrOptions is HyperdxInitConfig =>
  configOrOptions !== undefined &&
  'service' in (configOrOptions as Record<string, unknown>);
